import Api from './api'
import Auth from './auth'
import Middleware from './middleware'
import VerificationPermits from './permissions'
import Toast from './toast'
import Helper from './helper'

export { Api, Auth, Middleware, VerificationPermits, Toast, Helper }



// WEBPACK FOOTER //
// ./src/services/index.js